export default "assets/images/underline-6e359f70.svg";